import { InternalAxiosRequestConfig } from 'axios'
import { getStore } from '../../../../state/configure_store'

export const applyCurrentAuthorizationHeader = (
  config: InternalAxiosRequestConfig
) => {
  const accessToken = getStore()?.getState().token.token?.accessToken

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`)
  } else {
    config.headers.delete('Authorization')
  }

  return config
}
